import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

import { APIResults, AssemblyConfig } from "./sharedinterfaces";

export const RECENT_OPERATIONS_LIMIT = 2000;
export const ADMIN_OPERATIONS_LIMIT = 5000;

export class DvsUtilities {
	static FlattenComponents(componenttree: APIResults.AssetComponentList): AssemblyConfig.ComponentBase[] {
		const results: AssemblyConfig.ComponentBase[] = [];
		for (const engine of componenttree.engine) {
			results.push(engine);
		}
		for (const tach of componenttree.tach) {
			results.push(tach);
		}
		// No trackers currently in AssetComponentList
		for (const shaft of componenttree.shaft) {
			results.push(shaft);
			for (const gear of shaft.gear) {
				results.push(gear);
			}
			for (const bearing of shaft.bearing) {
				results.push(bearing);
			}
		}
		for (const flutter of componenttree.flutter) {
			results.push(flutter);
		}
		for (const sensor of componenttree.sensor) {
			results.push(sensor);
		}
		return results;
	}

	public static FindComponentAndShaftById(componenttree: APIResults.AssetComponentList, componentid: string): { component: AssemblyConfig.Component, shaft?: AssemblyConfig.Shaft } {
		for (const engine of componenttree.engine) {
			if (engine.id === componentid) {
				return { component: engine };
			}
		}
		for (const tach of componenttree.tach) {
			if (tach.id === componentid) {
				return { component: tach };
			}
		}
		for (const shaft of componenttree.shaft) {
			if (shaft.id === componentid) {
				return { component: shaft };
			}
			for (const gear of shaft.gear) {
				if (gear.id === componentid) {
					return { component: gear, shaft: shaft };
				}
			}
			for (const bearing of shaft.bearing) {
				if (bearing.id === componentid) {
					return { component: bearing, shaft: shaft };
				}
			}
		}
		for (const flutter of componenttree.flutter) {
			if (flutter.id === componentid) {
				return { component: flutter };
			}
		}
		for (const sensor of componenttree.sensor) {
			if (sensor.id === componentid) {
				return { component: sensor };
			}
		}
		for (const tracker of componenttree.tracker) {
			if (tracker.id === componentid) {
				return { component: tracker };
			}
		}
		return null;
	}

	static FeetToMeters(feet: number): number {
		return feet * 0.3048;
	}

	static AltitudeToTruncatedMeters(feet: number, baseElevationM: number): number {
		return Math.max(this.FeetToMeters(feet) - baseElevationM, 0);
	}

	static AddDegreeOffset(degrees: number, offset: number): number {
		if (!offset) return degrees;
		return (degrees + offset + 720.0) % 360.0;
	}

	static ReduceArray(array: any[], newLength: number, addLast = false) {
		if (newLength >= array.length) {
			return array.slice();
		}
		const factor = array.length / (array.length - newLength);
		const reduced = array.filter((e, i) => Math.floor(i % factor));
		// Add last element if requested
		if (addLast) {
			reduced.push(array[array.length - 1]);
		}
		return reduced;
	}

	static GetRemoteErrorMessage(err: any, fallback: string): string {
		if (err && err.error && err.error.message) return err.error.message;
		// Ignore HTTP status messages
		if (err && err.message && !err.message.toLowerCase().startsWith("http")) return err.message;
		return fallback;
	}

	static FormatNgbDate(date: NgbDateStruct, empty: string): string {
		return date ? date.year + "-" + date.month.toString().padStart(2, "0") + "-" + date.day.toString().padStart(2, "0") : empty;
	}

	public static GetOpClass(operation: APIResults.Operation): string {
		if (operation.exceedance_count > 0 && !operation.exceedance_ack_by) {
			return "unacked-ex";
		} else if (operation.exceedance_count > 0 && operation.exceedance_ack_by) {
			return "acked-ex";
		} else if (operation.exceedance_count === 0) {
			return "no-ex";
		} else {
			return "";
		}
	}
}